<template lang="pug">
	#sfc-main-container
		sfc-menu
		sfc-menu-mobile.menu-mobile
		#sfc-main-content
			nuxt
</template>

<style lang="stylus" scoped>

	.new-header-back-desktop
		>>>.menu-container
			max-width: 100% !important
			padding: 0 24px !important
		>>>.second-item-new-menu
		>>>.third-item-new-menu
			display: none !important
	.menu-mobile
		>>> .hamburger-icon
			display: none

		>>>.sfc-logo-mobile
			@media(max-width: 280px)
				display: block !important
</style>

<script>
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
export default {
	components:{
		SfcMenu,
		SfcMenuMobile
	},
	data(){
		return{
		}

	}
}
</script>
